<template>
  <!-- TODO: 查看客服对话、插入/协助对话、抢接对话、超时预警提醒 -->
  <div class="app">
    <splitpanes class="default-theme">
      <pane size="30">
        <bd-aside></bd-aside>
      </pane>
      <pane size="53">
        <splitpanes horizontal>
          <pane size="8" min-size="6">
            <bd-top></bd-top>
          </pane>
          <pane size="79">
            <bd-message></bd-message>
          </pane>
          <pane size="23" min-size="15">
            <bd-input></bd-input>
          </pane>
        </splitpanes>
      </pane>
      <pane size="35">
        <!-- <bd-right></bd-right> -->
      </pane>
    </splitpanes>
  </div>
</template>

<script>
// https://antoniandre.github.io/splitpanes/
import { Splitpanes, Pane } from "splitpanes";
import "splitpanes/dist/splitpanes.css";
import BdAside from "@/components/dashboard/main/monitor/threadAgent/BdAside";
// import BdTop from "@/components/dashboard/main/monitor/threadAgent/BdTop";
// import BdMessage from "@/components/dashboard/main/monitor/threadAgent/BdMessage";
// import BdInput from "@/components/dashboard/main/monitor/threadAgent/BdInput";
// import BdRight from "@/components/dashboard/main/monitor/threadAgent/BdRight";
import BdTop from '@/components/dashboard/main/chat/middle/BdTop'
import BdMessage from '@/components/dashboard/main/chat/middle/BdMessage'
import BdInput from '@/components/dashboard/main/chat/middle/BdInput'

export default {
  name: "bd-online",
  components: { BdAside, BdTop, BdMessage, BdInput, Splitpanes, Pane }, // BdRight,
  data() {
    return {};
  },
};
</script>

<style scope></style>